import { api } from '@/fsd/shared/api';
import {
  ICabinetsResponse,
  ICurrentCabinetResponse,
  IResponseCabinets,
} from '../../../feature/toggle-cabinet/models';

class CabinetApi {
  private static readonly url = `/api/v1/account/cabinet/`;

  static async create(name: string): Promise<ICurrentCabinetResponse | null> {
    return api.post<ICurrentCabinetResponse>(CabinetApi.url, {
      body: {
        name,
      },
    });
  }

  static async load(): Promise<ICabinetsResponse | null> {
    return api.get<ICabinetsResponse>(CabinetApi.url);
  }

  static async current(): Promise<ICurrentCabinetResponse | null> {
    const url = `/api/v1/account/current/cabinet/`;
    return api.get<ICurrentCabinetResponse>(url);
  }

  static async cabinets(): Promise<ICabinetsResponse | null> {
    const url = `/api/v1/account/cabinet/`;
    return api.get<ICabinetsResponse>(url);
  }

  static async remove(id: number): Promise<null> {
    return api.delete<null>(`${this.url}?id=${id}`);
  }

  static async rename(
    id: number,
    name: string
  ): Promise<ICurrentCabinetResponse | null> {
    return api.put<ICurrentCabinetResponse>(`${this.url}`, {
      body: {
        name,
        id,
      },
    });
  }
  static async switch(cabinet_id: number): Promise<{ message: string } | null> {
    return api.post<{ message: string }>(`${this.url}switch/`, {
      body: { cabinet_id },
    });
  }
}

export { CabinetApi };
